import React from "react";

// Last-resort safety net so a single render error in any page (e.g. trying
// to render a Pydantic 422 detail array as a child) does not blank the
// entire app. The user gets an explanation + a way out, instead of a
// black screen and lost form state.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    if (typeof window !== "undefined" && window.console) {
      // eslint-disable-next-line no-console
      console.error("[ErrorBoundary]", error, info?.componentStack);
    }
  }

  handleReload = () => { try { window.location.reload(); } catch {} };
  handleGoHome  = () => { try { window.location.assign("/"); } catch {} };

  render() {
    if (!this.state.error) return this.props.children;
    const message = (this.state.error && this.state.error.message) || "Unknown error";

    return (
      <div className="min-h-[70vh] flex items-center justify-center px-6">
        <div className="max-w-lg w-full border border-border1 p-8 bg-surface">
          <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-tier_demo_tx">/error</div>
          <h1 className="font-display text-2xl mt-2 mb-2 text-text1">Something broke on this page</h1>
          <p className="font-body text-sm text-text2 mb-4">
            We caught a render error before it could blank the app. Your session and any saved data are safe.
          </p>
          <pre className="font-mono text-[11px] text-text2 border border-border1 bg-black p-3 mb-5 whitespace-pre-wrap break-words">
            {String(message)}
          </pre>
          <div className="flex items-center gap-2">
            <button onClick={this.handleReload} className="font-mono text-xs uppercase bg-amber1 text-black px-4 h-10 hover:bg-amber2">Reload page</button>
            <button onClick={this.handleGoHome} className="font-mono text-xs uppercase border border-border1 text-text1 px-4 h-10 hover:border-amber1">Go home</button>
          </div>
        </div>
      </div>
    );
  }
}
